import type { Exercise } from "../../api/types";

/** Champ des Données initiales à désigner quand une partie d'un dossier incomplet est demandée (R12) : le niveau
 *  de l'ordre s'il manque, sinon le camp (les deux conditions d'un dossier complet, `isComplete`) ; à défaut, le
 *  nom du dossier. Cibles `data-attention` des Données initiales. */
export type MissingField = "dossier-level" | "dossier-camp" | "dossier-name";

export function missingField(ex: Pick<Exercise, "map_slug" | "parameters">): MissingField {
  if (!ex.parameters.level) return "dossier-level";
  if (!ex.map_slug) return "dossier-camp";
  return "dossier-name";
}
